require('./brokerWarrantsAdvancedBuySuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const AdvancedBuySellWarrantsSummary = require('components/broker/commons/advancedBuySellWarrantSummary/advancedBuySellWarrantSummary');

// @ helpers
const { formatText } = require('core/i18n').i18n;

const BrokerWarrantsAdvancedBuySuccess = props => {
    const { immProductFile, immBrokerWarrantsAdvancedBuy, immStocksContract } = props;
    const successMessage = formatText('broker-warrantsAdvancedBuySuccessStepMessage');
    const mainButtonLabel = formatText('broker-stocksAdvancedBuySuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('broker-warrantsAdvancedBuySuccessWizardSecondaryButtonLabel');

    return (
        <WizardSuccess
            successMessage={successMessage}
            customClassName="warrants-advanced-buy-success"
            mainButton={{label: mainButtonLabel, url:'/myprofile/broker', modifier: 'secondary'}} //@hardcoded TODO fix urls
            secondaryButton={{label: secondaryButtonLabel, url:'/myprofile/broker'}}
        >
            <div>
                <h3 className="warrants-advanced-buy-success__summary-header">
                    {formatText('broker-stocksAdvancedBuySuccessStepSubtitle')}
                </h3>
                <AdvancedBuySellWarrantsSummary
                    immProductFile={immProductFile}
                    immBrokerWarrantsAdvancedState={immBrokerWarrantsAdvancedBuy}
                    immStocksContract={immStocksContract}
                />
            </div>
        </WizardSuccess>
    );
};

BrokerWarrantsAdvancedBuySuccess.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedBuy: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired
};

module.exports = BrokerWarrantsAdvancedBuySuccess;